import { render } from "./MainDeliveryApp.vue?vue&type=template&id=5f549f32&scoped=true"
import script from "./MainDeliveryApp.vue?vue&type=script&lang=js"
export * from "./MainDeliveryApp.vue?vue&type=script&lang=js"

import "./MainDeliveryApp.vue?vue&type=style&index=0&id=5f549f32&scoped=true&lang=css"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f549f32"]])

export default __exports__